import { render, staticRenderFns } from "./secondBar.vue?vue&type=template&id=66b775f6&"
import script from "./secondBar.vue?vue&type=script&lang=js&"
export * from "./secondBar.vue?vue&type=script&lang=js&"
import style0 from "./secondBar.vue?vue&type=style&index=0&id=66b775f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports